/**
 * Uniforme prijsopmaak voor de hele site: Nederlands EUR-formaat (€ 1.234,56).
 * Robuust tegen null/undefined/strings.
 *
 * @param {number|string|null|undefined} price
 * @returns {string} bijv. "€ 1.234,56"
 */
export function formatPrice(price) {
  const n = parseFloat(price)
  if (!isFinite(n)) return '€ 0,00'
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(n)
}
